<template>
    <div>
        <div style="margin: 0px; padding: 0px;">
            <div style="background: #FFFFFF; color: #666666; padding-top: 5px; padding-bottom: 5px; font-weight: 400; text-align: center; width: 100%; font-size: 12px; font-family: PingFangSC-Regular, PingFang SC;">
                <span>开发者：{{developer}}</span><br/>
                <span>应用名称：提词蛙</span> <span style="padding-left: 20px;">版本号：1.3.0</span><br/>
                <span><a :href="secretUrl" style="color: #246DFF;">用户权限</a> | <a :href="secretUrl" style="color: #246DFF;">隐私协议</a></span>
            </div>
            <img :src="awaken_img" @click="openTargetApp" style="width: 100%; display: block;" title="awaken">
        </div>
        <div class="wxtip" v-show="wxtip">
            <img :src="awaken_img_wx_tip" style="width: 60%; padding-right: 16px;"/>
        </div>
    </div>
</template>

<script>
    import CallApp from 'callapp-lib'
    import MobileDetect from 'mobile-detect'
    import {awakenLogAdd} from "../api/log"

    export default {
        name: "teleprompterAwaken",
        data() {
            return {
                ua: '',
                md: '',
                os: '',
                developer: "北京中网易企秀科技有限公司",
                secretUrl: "https://lib.eqh5.com/app/private_prompter.html",
                awaken_img: "//asset.eqh5.com/app_awaken_10989?t="+ new Date().getFullYear() + "-" + new Date().getMonth()+ "-" + new Date().getDate() + "-" + new Date().getHours() +"&imageMogr2/auto-orient/thumbnail/" + (window.innerWidth * 1.5) + "x" + (window.innerHeight * 1.5),
                awaken_img_wx_tip: '//asset.eqh5.com/app_awaken_wxtip?t=' + new Date().getTime(),
                wxtip: false,
                option: {
                    scheme: {
                        protocol: 'teleprompterlink',
                    },
                    universal: {
                        host: 'appweb.eqxiu.com/teleprompter',
                        pathKey: ''
                    },
                    appstore: 'https://apps.apple.com/cn/app/Teleprompter/id6742123688',
                    fallback: "market://details?id=com.eqxiu.smartshot",
                    timeout: 2000,
                },
                packageKey: "com.eqxiu.smartshot"
            }
        },
        mounted() {
            document.title = this.$route.meta.title
            let params = this.$route.query
            let ccode = ''
            if (params.channelCode instanceof Array) {
                for (let code of params.channelCode) {
                    ccode += code + ","
                }
            } else {
                ccode = params.channelCode
            }
            if (ccode != undefined) {
                ccode = ccode.indexOf(",") > -1 ? ccode.substring(0, ccode.length -1) : ccode
            }
            this.option.universal.pathKey = 'channelCode=' + ccode
            this.ua = navigator.userAgent.toLowerCase();
            this.md = new MobileDetect(this.ua)
            let os = this.md.os();
            if (os == "iOS") {//ios系统的处理
                this.developer = "成都中网易企秀科技有限公司"
                this.secretUrl = "https://lib.eqh5.com/app/private_policy_prompter.html"
            } else if (os == "AndroidOS") {
                this.developer = "北京中网易企秀科技有限公司"
                this.secretUrl = "https://lib.eqh5.com/app/private_prompter.html"
            }
            this.os = os;
            if (this.isWx()) {
                this.wxtip = true;
            } else {
                this.wxtip = false;
            }

            //统计使用
            window.ilog = {};
            window.ilog['product'] = 'teleprompter'; //填写产品名
            window.ilog['b_v'] = '1.0.0'; //数据版本
            window.ilog['b_t'] = '提词蛙中间页'; //业务类型
            window.ilog['unm'] = '下载落地页'; //页面名字
            setTimeout(() => {
                if (!this.isWx()) {
                    this.openApp();
                }
            }, 1000)
        },
        methods: {
            openTargetApp() {
                window.location.reload(true)
            },
            openApp() {
                let ua = navigator.userAgent.toLowerCase();
                let md = new MobileDetect(ua)
                //指定页面唤起使用
                let params = this.$route.query;

                if (this.isMiuiBrowser() || this.isVivoBrowser() || this.isHeyTapBrowser()) {
                    this.option.fallback = "https://lib.eqh5.com/app/apk/smartshot.apk"
                }
                var lib = new CallApp(this.option)
                let os = md.os();
                let model = "default";

                if (os == "iOS") {//ios系统的处理
                    model = md.mobile();
                } else if (os == "AndroidOS") {//Android系统的处理
                    var build = ua.split(";");
                    var i = build.findIndex(item => item.indexOf("build/") > -1);
                    if (i > -1) {
                        model = build[i].substring(0, build[i].indexOf("build/"));
                    }
                    model == "default" ? model = build[2] : "default"
                    if (model.trim() == "HarmonyOS" || model.trim() == "harmonyos") {
                        model = build[3]
                    }
                }
                var channelCode = "default"
                if (params.channelCode instanceof Array) {
                    for (let code of params.channelCode) {
                        var reg = /^\d+.*$/
                        if (!reg.test(code)) {
                            channelCode = code;
                        }
                    }
                } else {
                    channelCode = params.channelCode
                }

                let ccode = this.$cookies.get("channelCode")
                if (ccode != null && ccode != undefined && ccode != "") {
                    params.channelCode = params.channelCode + "," + ccode
                }
                params.url = window.location.href
                console.log("========================" + model)
                awakenLogAdd({"model": model.trim(), "params": JSON.stringify(params), "channelCode": channelCode}).then(res => {
                    console.log(JSON.stringify(res))
                    //下边open 会有跳转
                    lib.open({path: ''})
                })
            },
            isAndroid() {
                var md = new MobileDetect(navigator.userAgent.toLowerCase())
                var os = md.os();
                if (os == "AndroidOS") {
                    return true;
                }
                return false;
            },
            isiOS() {
                var md = new MobileDetect(navigator.userAgent.toLowerCase())
                var os = md.os();
                if (os == "iOS") {
                    return true;
                }
                return false;
            },
            isWx(){//判断是否为微信
                if(navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'){
                    return true;
                }
                return false;
            },
            isMiuiBrowser() {
                if(navigator.userAgent.toLowerCase().match(/miuibrowser/i) == 'miuibrowser'){
                    return true;
                }
                return false;
            },
            isVivoBrowser() {
                if(navigator.userAgent.toLowerCase().match(/vivobrowser/i) == 'vivobrowser'){
                    return true;
                }
                return false;
            },
            isHeyTapBrowser() {
                if(navigator.userAgent.toLowerCase().match(/heytapbrowser/i) == 'heytapbrowser'){
                    return true;
                }
                return false;
            }
        }
    }
</script>

<style scoped>
    .wxtip {
        background: rgba(0,0,0,0.8);
        text-align: right;
        position: fixed;
        left:0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 998;
    }
</style>
